import { withLiteObserverAndTheme } from "../../../../../core/et3-enhanced-render";
import ET3Div from "../../../../../core/et3-div";
import Et3Margin from "../../../../../core/et3-ui/ET3Margin";
import Et3Button from "../../../../../core/et3-button";
import getKhattabat101MGeneralStore from "../../../../../stores/khattabat-stores/101m-stores/general-101m-store";
import getKhattabatMatchingStore from "../../../../../stores/khattabat-stores/matching-stores";

const Actions = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="row"
      justifyContent="flex-start"
      alignItems="flex-end"
      withShadow={false}
      width={1200}
      height={90}
      color={colors.all.transparent}
      style={{}}
      onClick={() => {}}
    >
      <Et3Margin top={0} bottom={0} left={40} right={0} />
      <Et3Button
        isEnabled={getKhattabat101MGeneralStore().canOpenOneOOneMConversations.get()}
        onClick={async () =>
          await getKhattabatMatchingStore().openOneOOneMConversations()
        }
        type="SEND"
        size="LARGE"
        text="SEND"
      />
    </ET3Div>
  );
});

export default Actions;
